import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access, apiErrorSchema } from './schemas/common.js';
import { recordKindSchema, recordSchema } from './schemas/domain.js';
const c = initContract();
/**
 * Query values arrive as strings over the wire, so the numbers are coerced —
 * with the input type spelled out, so a typed client may pass a real number and
 * still type-check.
 */
export const recordQuerySchema = z.object({
    kind: recordKindSchema.optional(),
    sourceId: z.string().optional(),
    since: z.iso.datetime().optional(),
    until: z.iso.datetime().optional(),
    search: z.string().optional(),
    /** Any-of match against the indexed search text. Repeat the parameter. */
    terms: z.union([z.string(), z.array(z.string())]).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
    offset: z.coerce.number().int().min(0).optional(),
});
export const recordsContract = c.router({
    list: {
        method: 'GET',
        metadata: access('admin'),
        path: '/records',
        summary: 'Search stored records. The core clamps the page size.',
        query: recordQuerySchema,
        responses: {
            200: z.object({
                records: z.array(recordSchema),
                total: z.number().int(),
            }),
            400: apiErrorSchema,
        },
    },
});
//# sourceMappingURL=records.contract.js.map